var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoryTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.257 22.374l-.697 2.09a1.167 1.167 0 001.107 1.535h4.666a1.167 1.167 0 001.107-1.535l-.697-2.09a30.39 30.39 0 01-2.743.125c-.97 0-1.89-.048-2.743-.125z",
    fill: "#9C4D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.175 3.008a1.167 1.167 0 011.65 0l4.666 4.667c.364.363.447.921.204 1.374-.288.54-.738.905-1.178 1.152l3.308 3.307a1.167 1.167 0 010 1.65c-.558.558-1.262.899-1.906 1.11l3.072 3.073a1.167 1.167 0 01-.456 1.932c-.805.267-1.642.454-2.473.62A31.246 31.246 0 0114 22.5c-2.428 0-4.548-.304-6.062-.607-.831-.166-1.662-.354-2.468-.618a1.167 1.167 0 01-.462-1.934l3.073-3.072c-.644-.212-1.348-.553-1.906-1.111a1.167 1.167 0 010-1.65L9.482 10.2c-.439-.247-.89-.612-1.178-1.152a1.167 1.167 0 01.204-1.374l4.667-4.667z",
    fill: "#00B05D"
  })));
}

export default SvgStoryTree;